import { Brand } from '@aura/contextos-frontend/dist/contexts/config/config.types';

export enum ModalidadePeriodo {
  FLEX = 'FLEX',
  EAD = 'EAD',
  AO_VIVO = 'AO VIVO',
  PRESENCIAL = 'PRESENCIAL',
  SEMI = 'SEMI',
}

export enum TipoCurso {
  GRADUACAO_TECNOLOGICA = 'GRADUAÇÃO TECNOLÓGICA',
  GRADUACAO = 'GRADUAÇÃO',
  ESPECIALIZACAO = 'ESPECIALIZAÇÃO',
  TECNICO = 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO',
}

export interface ElegibilidadeSecaoAvaliacoes {
  marcas: Array<Brand>;
  tipoCurso: Array<TipoCurso>;
  modalidades: Array<ModalidadePeriodo>;
}

export type ElegibilidadeSecaoAvaliacoesConfig = Array<ElegibilidadeSecaoAvaliacoes>;
